import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { IconByString } from '../IconByString';

interface InfoModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  title: string;
  description: string | React.ReactNode;
  infoText?: string | React.ReactNode;
  icon?: string;
}

export const InfoModal = ({
  open,
  setOpen,
  title,
  description,
  infoText,
  icon = 'Info',
}: InfoModalProps) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow:
            '0px 12px 24px -4px rgba(145, 158, 171, 0.12), 0px 0px 2px 0px rgba(145, 158, 171, 0.2)',
        },
      }}
    >
      <DialogTitle sx={{ m: 0, p: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box
          sx={{
            p: 1,
            borderRadius: 2,
            bgcolor: 'rgba(102, 60, 193, 0.08)',
            display: 'flex',
            color: '#663cc1',
          }}
        >
          <IconByString iconName={icon} />
        </Box>
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        </Box>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 16,
            top: 24,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        dividers
        sx={{ borderTop: '1px solid #32475C1F', borderBottom: '1px solid #32475C1F', p: 3 }}
      >
        {infoText && (
          <Box
            sx={{
              p: 2,
              borderRadius: 2,
              bgcolor: 'rgba(105, 108, 255, 0.08)',
              display: 'flex',
              alignItems: 'flex-start',
              gap: 1.5,
            }}
          >
            <InfoOutlinedIcon sx={{ color: '#696CFF', mt: 0.2 }} fontSize="small" />
            <Typography variant="body2" sx={{ color: '#4244A6', fontWeight: 500 }}>
              {infoText}
            </Typography>
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 3 }}>
        <Button
          onClick={handleClose}
          variant="contained"
          color="primary"
          sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}
        >
          Entendido
        </Button>
      </DialogActions>
    </Dialog>
  );
};
